define('views/components/credit_card/credit_cards',['require','backbone','views/components/credit_card/credit_card','models/credit_card','text!templates/components/credit_card/credit_cards.html'],function(require){

    var Backbone = require('backbone');
    var ChildView = require('views/components/credit_card/credit_card');

    var CreditCardModel = require('models/credit_card');

    var temp = require("text!templates/components/credit_card/credit_cards.html");

    return Backbone.Marionette.CompositeView.extend({
        template: _.template(temp),
        tagName: 'div',
        childViewContainer: '.current-credit-cards',
        childView: ChildView,
        selectedCreditCard: null,
        creditCardsFetched: false,

        initialize: function () {
            this.listenTo(this.collection, 'fetch_complete', this._onFetch);
            this.collection.fetch();

            this.currentBin = null;
        },

        ui: function() {
            return {
                select2Input: '[data-init-plugin="select2"]',

                creditCardSelect: '[name="credit_card_option"]',
                newCreditCardOption: '#cc_new',
                newCardRow: '.new-card-row',

                cardHolderName: '#card_holder_name',
                cardNumber: '#card_number',
                cardExpiryYear: '#expiry_year',
                cardExpiryMonth: '#expiry_month',
                cardCvc: '#card_cvc',
                saveCardCheck: '#save_card',

                visa: "#visa",
                amex: "#amex",
                mastercard: "#mastercard"
            };
        },

        events: {
            'click @ui.creditCardSelect': 'creditCardSelectClicked',
            'change @ui.cardNumber': 'cardNumberChanged'
        },

        onRender: function () {
            this.ui.select2Input.select2();

            if (this.creditCardsFetched && !this.collection.models.length) {
                // If no previous credit cards, select new option by default
                this.ui.newCreditCardOption.prop('checked', true);
                this.ui.newCardRow.removeClass('hidden');
                this.selectedCreditCard = 'new';
            }
        },

        _onFetch: function () {
            this.creditCardsFetched = true;
            this.render();
        },

        creditCardSelectClicked: function () {
            var creditCardValue = $('[name="credit_card_option"]:checked').val();

            this.selectedCreditCard = creditCardValue;

            if (creditCardValue == 'new') {
                this.ui.newCardRow.removeClass('hidden');
            } else {
                this.ui.newCardRow.addClass('hidden');
            }

            this.trigger('credit_card');
        },

        cardNumberChanged: function() {
            var binNumber = this.ui.cardNumber.val().substr(0, 6);
            if (binNumber != this.currentBin) {
                this.currentBin = binNumber;
                this.trigger('bin_number_changed');
            }
        },

        getSelectedCreditCard: function () {
            if (this.selectedCreditCard == 'new') {
                return new CreditCardModel({
                    'card_holder_name':  this.ui.cardHolderName.val(),
                    'card_number':  this.ui.cardNumber.val(),
                    'card_expiry':  this.ui.cardExpiryMonth.val() + '/' + this.ui.cardExpiryYear.val(),
                    'card_cvc':  this.ui.cardCvc.val(),
                    'save_card':  this.ui.saveCardCheck.prop('checked')
                }).toJSON();
            } else {
                return this.selectedCreditCard;
            }
        },
        detectCardType: function (cardNumber) {
            var visaRegEx = /^4/;
            var amexpRegEx = /^3[47]/;
            var masterRegEx = /^(5[1-5]|2(22[1-9]|2[3-9]|[3-6]|7[0-1]|720))/;
            
            if (visaRegEx.test(cardNumber)) {
                return "visa";
            } else if (amexpRegEx.test(cardNumber)) {
                return "amex";
            } else if (masterRegEx.test(cardNumber)) {
                return "mastercard";
            }
            return false;
        }
    });
});

